import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material'
import { GroupLimit } from '@types'
import { copyValue } from '@utils'
import { DateTime } from 'luxon'
import { useMemo } from 'react'

interface Props {
    limit: GroupLimit
}

export default function GroupLimitPane({ limit }: Props): JSX.Element {
    const fromDate = useMemo(
        () => DateTime.fromISO(limit.from_date).toFormat('DD HH:mm:ss'),
        [limit]
    )
    const toDate = useMemo(() => {
        if (limit.to_date) {
            return DateTime.fromISO(limit.to_date).toFormat('DD HH:mm:ss')
        }
        return 'N/A'
    }, [limit])
    return (
        <Paper sx={{ height: '100%' }}>
            <Typography variant="h3">Limit</Typography>
            <Grid container spacing={1}>
                <Grid item xs={3}>
                    <Typography variant="body1">Limit ID:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="subtitle1">
                        {limit.id}
                        <Tooltip title="Copy Limit ID">
                            <IconButton
                                size="small"
                                onClick={copyValue(limit.id)}
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">Limit:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="body1">
                        {limit.limit / 60 / 60}hrs
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">Start Date:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="body1">{fromDate}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">End Date:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="body1">{toDate}</Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}
